import axios from 'axios';
import errorHandling from '@/js/errorHandling';

// function getServiceUrl() {
//   const env = process.env.VUE_APP_API_ENDPOINT;
//   return env;
// }

async function callService(url, params, method) {
  try {
    let response = await axios({
      method,
      url,
      data: method == methodTypes.get 
        || method == methodTypes.delete ? null : params,
      params: method == methodTypes.get 
        || method == methodTypes.delete ? params : null
    });
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      handleError({message:"Your session has expired. Please click OK to refresh the page."}, true);
    } else {
      handleError(error, false);
    }
  }
   
}

async function callApi(url, params, method) {
    let response = await axios({
      method: method,
      url: url,
      data: params
    });
    return response;
}


function handleError(error, displayMessage) {
  console.log(error);
  if (displayMessage) {
    errorHandling.showMessage(error.message, true, false);
  }  
}

const methodTypes = { post: 'post', get: 'get', put: 'put', delete: 'delete' };

export default {

  SetAuthToken(token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  },
  ClearAuthToken() {
    delete axios.defaults.headers.common['Authorization'];
  },
  SetTestSiteCode(siteCode) {
    axios.defaults.headers['Testsitecode'] = siteCode;
  },
  ClearTestSiteCode() {
    delete axios.defaults.headers['Testsitecode'];
  },
  ClearIsMFAEnabled() {
    axios.defaults.headers['IsMFAEnabled'] = "N";
  },
  SetIsMFAEnabled(isMFAEnabled) {
    axios.defaults.headers['IsMFAEnabled'] = isMFAEnabled;
  },
  
  async GetSiteData() {
     // eslint-disable-next-line prefer-template
     const response = await callService('SiteData', null, methodTypes.get);
     return response.data;
  },
  async ValidateRecaptcha(action, token){
    const response = await callService('ReCaptcha', {action: action, token: token}, methodTypes.post);
    return response.data;
  },
  async Authenticate(user, action, token){
    const response = await callService('authorize', {user: user, action: action, token: token}, methodTypes.post);
    return response.data;
  },
  async LoginUser(user, action, token){
    try {
      const response = await callApi('v1.0/account/auth', {userDetails: user, recaptchaToken: {action: action, token: token}}, methodTypes.post);

       return {
        isSuccessful: true,
        data: response.data.data,
        status: response.status
      };
    } catch (error) {
       if (error.response) {
        return {
          isSuccessful: false,
          errorCode: error.response.data.errorCode,
          data: error.response.data.data,
          status: error.response.status
        };
      } else {
        // Some other error (like network error, timeout)
        return {
          isSuccessful: false,
          errorCode: "UNKNOWN_ERROR",
          data: null,
          status: 0
        };
      }
    }
  },
    async VerifyOTP(otp) {
    try {
      let response = await callApi(
        "v1/account/verify-otp",
        { otp: otp },
        methodTypes.post
      );
  
      return {
        isSuccessful: true,
        data: response.data.data,
        status: response.status
      };
  
    } catch (error) {
      if (error.response) {
        return {
          isSuccessful: false,
          errorCode: error.response.data.errorCode,
          data: error.response.data.data,
          status: error.response.status
        };
      } else {
         return {
          isSuccessful: false,
          errorCode: "UNKNOWN_ERROR",
          data: null,
          status: 0
        };
      }
    }
  },
  async GetAvailbleLocations(city, zip, serviceTypeId, serviceTypeId2, startDate) { 
    const response = await callService('AvailableLocation', {typeId: serviceTypeId, typeId2: serviceTypeId2, zipCode: zip, cityName: city, startDate: startDate}, methodTypes.get);
    return response.data;
  },
  async GetLocationsWithServiceType(serviceTypeId, serviceTypeId2, startDate) {
    const response = await callService('Locations', {serviceTypeId: serviceTypeId, serviceTypeId2: serviceTypeId2, startDate: startDate}, methodTypes.get);
    return response.data;
  },
  async GetLocationsWithServiceTypeByCounty(serviceTypeId, serviceTypeId2, startDate) {
    const response = await callService('LocationsByCounty', {serviceTypeId: serviceTypeId, serviceTypeId2: serviceTypeId2, startDate: startDate}, methodTypes.get);
    return response.data;
  },
  async GetLocationByLocationId(serviceTypeId, serviceTypeId2, startDate, locationId) {
    const response = await callService('LocationByLocationId', {serviceTypeId: serviceTypeId, serviceTypeId2: serviceTypeId2, startDate: startDate, locationId: locationId}, methodTypes.get);
    return response.data;
  },
  async GetLocationAvailability(locationId, typeId, typeId2, startDate) {
    startDate = startDate || new Date();
    const response = await callService('AvailableLocationDates', {locationId: locationId, typeId: typeId, typeId2: typeId2, startDate: startDate }, methodTypes.get);
    return response.data;
  },
  async GetBooking(email, phoneNumber, confirmationNumber) {
    const response = await callService('Booking', {email: email, phoneNumber:phoneNumber, confirmationNumber: confirmationNumber}, methodTypes.get);
    if(response.data.token) {
      this.SetAuthToken(response.data.token);
    }
    return response.data.bookings;
  },
  async SaveBooking(serviceTypeId, serviceTypeId2, bookingDateTime, bookingDuration, firstName, lastName, email, cellPhone, siteId, slotId, dateOfBirth) {
    const bookingData = {serviceTypeId: serviceTypeId, serviceTypeId2: serviceTypeId2, bookingDateTime: bookingDateTime, bookingDuration: bookingDuration, firstName: firstName,
      lastName: lastName, email: email, cellPhone: cellPhone, sendSms: cellPhone ? true : false, siteId: siteId, slotId: slotId, dateOfBirth: dateOfBirth
    };
    const response = await callService('Booking', bookingData, methodTypes.post);
    return response.data;
  },
  async RescheduleBooking(serviceTypeId, serviceTypeId2, bookingDateTime, bookingDuration, firstName, lastName, email, cellPhone, siteId, slotId, dateOfBirth) {
    const bookingData = {serviceTypeId: serviceTypeId, serviceTypeId2: serviceTypeId2, bookingDateTime: bookingDateTime, bookingDuration: bookingDuration, firstName: firstName,
      lastName: lastName, email: email, cellPhone: cellPhone, sendSms: cellPhone ? true : false, siteId: siteId, slotId: slotId, dateOfBirth: dateOfBirth
    };
    const response = await callService('Booking', bookingData, methodTypes.put);
    return response.data;
  },
  async CancelBooking(bookingId) {
    const response = await callService('Booking', { bookingId: bookingId }, methodTypes.delete);
    return response.data;
  },
  async GetServiceTypes(locale) {
    const response = await callService(`ServiceTypes/${locale}`, null, methodTypes.get);
    return response.data;
  },
  async CheckInReservation(confirmationNumber, lat, lon) {
    const response = await callService('Checkin', {confirmationNumber: confirmationNumber, lat:lat, lon:lon}, methodTypes.get);
    return response.data;
  },
  async GetTicketData(ticketGuid) {
    const response = await callService(`Ticket/${ticketGuid}`, null, methodTypes.get);
    return response.data;
  }
};
